<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <questions-table />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import QuestionsTable from "./components/QuestionsTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    QuestionsTable,
    // ProjectsTable,
  },
};
</script>
